import React from 'react';
function NativeScrollArea(_ref) {
  let {
    children
  } = _ref;
  return /* @__PURE__ */React.createElement(React.Fragment, null, children);
}
export { NativeScrollArea };